class ResellerForm extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.select = this.querySelector('select');
    this.other = this.querySelector('.reseller-form__input--other');
    this.select.addEventListener('change', () => this.toggleOther(), { signal: this.controller.signal });
    this.toggleOther();

    const success = this.querySelector('.reseller-form__success');
    if (success) success.scrollIntoView({ block: 'center' });
  }

  disconnectedCallback() {
    this.controller.abort();
  }

  toggleOther() {
    const isOther = this.select.value === this.select.dataset.other;
    this.other.hidden = !isOther;
    this.other.disabled = !isOther;
  }
}

customElements.define('reseller-form', ResellerForm);
